(function () {
  'use strict';
  
  /**
   * @ngdoc service
   * @name vcdms.pdfprinter.factory:Pdfprinter
   *
   * @description
   *
   */
  angular
    .module('vcdms.vcpdfprinter')
    .factory('Pdfprinter', Pdfprinter);
  
  
  Pdfprinter.$inject = ['restmod'];
  function Pdfprinter(restmod) {
    return restmod.model('/routes/pdfprinters').mix({
      created: {
        init: function () {
          return moment().toISOString();
        }
      },
      active: {init: true},
      $extend: {
        Model: {
          $searchahead: function (_params) {
            return this.$collection().$decorate({
              'before-request': function (_req) {
                _req.method = 'GET';
                _req.url = '/routes/pdfprinters/searchahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          }
        } // Model
      }// extend
    });
  }
  
// klammerfriedhof
}());
